import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { FiltersComp } from './filters';
import { AddNewUser, GetProcessList, GetUserDetails, UpdateUserDetails } from '../../models/process';
import { pnkstore } from '../../stores/pnk-store';
import { useUserStore } from '../../stores/user-store';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { GetAllProject, GetAreasList, GetCitiesList, GetDistrictList, GetStatesList } from '../../models/project';
import { AddNewLead, GetAllInstitutes, GetAllLeads, UpdateLead, UpdateLeadDesc } from '../../models/leads';
import { GetProfileList } from '../../models/profile';
import { GetUserList } from '../../models/user';

export const Filters = (props) => {
    const userData = useUserStore;
    const [SearchFormData, setSearchFormData] = useState({
        'txtLeadSearchStartDate': '',
        'txtLeadSearchEndDate': '',
        'ddlLeadSearchOwner': [],
        'ddlLeadSearchProject': [],
    });
    const [getStateList, setGetStateList] = useState(false);
    const [stateListData, setStateListData] = useState([]);
    const [statusListData, setStatusListData] = useState([]);
    const [getCityList, setGetCityList] = useState(false);
    const [cityListData, setCityListData] = useState([]);

    const [getProfileList, setGetProfileList] = useState(true);
    const [profileListData, setProfileListData] = useState([]);
    const [getUserList, setGetUserList] = useState(true);
    const [userListData, setUserListData] = useState([]);
    const [getProjectList, setGetProjectList] = useState(true);
    const [projectList, setProjectList] = useState([]);

    const [instituteSearchObj, setInstituteSearchObj] = useState({});
    const [getInstituteList, setGetInstituteList] = useState(true);
    const [instituteListData, setInstituteListData] = useState([]);

    const [showAlert, setShowAlert] = useState(false);
    const [alertType, setAlertType] = useState('');
    const [alertMsg, setAlertMsg] = useState('');

    const state = {
        userData: userData.getState(),
        stateListData: stateListData,
        profileListData: profileListData,
        userListData: userListData,
        showAlert: showAlert,
        alertMsg: alertMsg,
        alertType: alertType,
        pageType: props.page,
        statusListData: statusListData,
        type: props.type,
        instituteListData: instituteListData,
    }

    useEffect(() => {

        let statusArray = ['Pending', 'RNR', 'Hold', 'Dead', 'Call Back'];

        if (props.candidateStatus === 'Shortlisted') {
            statusArray = ['In Progress', 'S-Test', 'Test Completed', 'Interview Scheduled', 'Interview Completed', 'Selected', 'Rejected'];
        }
        else if (props.candidateStatus === 'On Board') {
            statusArray = ['Joined', 'Not Joined', 'Deferred Admission'];
        }

        if (props.type === 'Institute') {
            statusArray = ['UnCalled', 'RNR', 'Call Back', 'Active', 'Onboarding', 'Inactive'];
        }
        else if (props.type === 'Student') {
            statusArray = ["Preliminary Screening Done",
                "Language Screening Done",
                "Resume Ready",
                "Interview With Agency",
                "COL Issued",
                "COL Accepted Agreement Done",
                "Security Deposit Paid",
                "Interviewing With Hospital",
                "Final Offer Issued"];
        }

        setStatusListData(statusArray);

    }, []);


    const HandleInputs = (e, name) => {
        let value = '';
        if (name === 'txtLeadSearchStartDate' || name === 'txtLeadSearchEndDate') {
            value = e.$d;
            value = new Date(new Date(value).getTime() - (new Date(value).getTimezoneOffset() * 60000)).toISOString().substr(0, 10).replace('T', ' ')
        }
        else {
            value = e.target.value
        }
        setSearchFormData((prev) => ({ ...prev, [name]: value }));
        if (name == 'ddlLeadSearchState') {
            setGetCityList(true)
        }
    }


    const HandleCloseAlertMsg = (type) => {
        setTimeout(() => {
            setShowAlert(false);
            setAlertType('');
            setAlertMsg('');
        }, 2000)
    }

    const ToggleFilterBox = () => {
        props.ToggleFilter()
    }

    const SearchData = () => {

        // console.log(SearchFormData);

        if (SearchFormData.txtLeadSearchStartDate !== '') {
            if (SearchFormData.txtLeadSearchEndDate === '') {
                setShowAlert(true);
                setAlertMsg('Please Select End Date Also');
                setAlertType('error');
                return false;
            }
        }
        props.SearchList('filter', SearchFormData);
    }

    const HandleCityListResponse = (res) => {
        if (res != false) {
            let data = res.data.districtlistresponse.rows;
            setCityListData(data);
        }
        else {
            setCityListData([]);
        }

        setGetCityList(false);
    }




    const HandleProjectListSuccessResponse = (res) => {
        if (res != false && res != 'error') {
            let projectListData = res.data.proplistresponse.rows
            setProjectList(projectListData);
        }
        else {
            setProjectList([]);
        }
        setGetProjectList(false);
    }


    const HandleStateListResponse = (res) => {
        console.log(res.data.statelistresponse.rows);
        if (res != false) {
            setStateListData(res.data.statelistresponse.rows);
        }
        else {
            setStateListData([]);
        }
        setGetStateList(false)
    }


    const HandleGetProfilesListSuccessResponse = (res) => {
        if (res != false && res != 'error') {
            console.log(res);
            let profileListData = res.data.profilelistresponse.rows
            setProfileListData(profileListData);
        }
        else {
            setProfileListData([]);
        }
        setGetProfileList(false);
    }

    const HandleGetUsersListSuccessResponse = (res) => {
        if (res != false && res != 'error') {
            console.log(res);
            let usersListData = res.data.userlistresponse.rows
            setUserListData(usersListData);
        }
        else {
            setUserListData([]);
        }
        setGetUserList(false);
    }

      const HandleGetInstituteListSuccessResponse = (res) => {
        setGetInstituteList(false);
        if (res !== false) {
            setInstituteListData(res.data.leadlistresponse.rows)
        }
        else {
            setInstituteListData([]);
        }
    }


    return (
        <Box>
            <FiltersComp
                mystate={state}
                HandleInputs={HandleInputs}
                cityListData={cityListData}

                projectList={projectList}
                SearchFormData={SearchFormData}
                ToggleFilterBox={ToggleFilterBox}
                SearchData={SearchData}
                HandleCloseAlertMsg={HandleCloseAlertMsg}
            />
            {((getUserList === true) ? GetUserList(pnkstore, {}, userData.getState().token, HandleGetUsersListSuccessResponse) : "")}
            {((getProfileList === true) ? GetProfileList(pnkstore, {}, userData.getState().token, HandleGetProfilesListSuccessResponse) : "")}
            {((getStateList === true) ? GetStatesList(pnkstore, userData.getState().token, HandleStateListResponse) : "")}
            {((getCityList === true) ? GetDistrictList(pnkstore, SearchFormData.ddlLeadSearchState, userData.getState().token, HandleCityListResponse) : "")}
            {((getProjectList === true) ? GetAllProject(pnkstore, {}, userData.getState().token, HandleProjectListSuccessResponse) : "")}
            {((getInstituteList === true) ? GetAllInstitutes(pnkstore, {}, userData.getState().token, HandleGetInstituteListSuccessResponse) : "")}
        </Box>
    )
}